export default { open: false, conversationId: null };
